import { Component, OnInit } from '@angular/core';
import { CollectionSorter } from '@bryntum/scheduler/scheduler.module.js';
import { BookingEditorService } from '../../../services/booking-editor/booking-editor.service';

@Component({
  selector: 'sb-booking-editor-sorters',
  templateUrl: './sb-booking-editor-sorters.component.html',
  styleUrls: ['./sb-booking-editor-sorters.component.scss'],
  standalone: false,
})
export class SbBookingEditorSortersComponent implements OnInit {
  constructor(public bookingEditor: BookingEditorService) {}

  isAllCollapsed: boolean;

  ngOnInit(): void {}

  resolveSortIcon() {
    const sorters: CollectionSorter = this.bookingEditor.resourceStore.sorters;
    return !sorters[0]?.ascending;
  }

  toggleAllCollapse() {
    if (this.isAllCollapsed) {
      this.bookingEditor.scheduler.schedulerInstance.expandAll();
      this.isAllCollapsed = false;
    } else {
      this.bookingEditor.scheduler.schedulerInstance.collapseAll();
      this.isAllCollapsed = true;
    }
  }
}
